export default "__VITE_ASSET__BJqtZiZ3__"